export enum LandingPageEnum {
    Default = 0,
    SharePoint = 1,
    Teams = 2,
    OneDrive = 3,
    Exchange = 4,
    Tess = 5
}